import React from 'react';
import { injectIntl } from 'react-intl';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { SlideTransition } from '../../../../components/Transition/Transition';
import { Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import './ConfirmAddPolicyDialog.scss';

const ConfirmAddPolicyDialog = props => {
  const { intl, onClose, onSubmit, onRider, onAnother, onExport, title, ...rest } = props;

  return (
    <Dialog
      className="confirm-add-policy-dialog"
      fullWidth={true}
      {...rest}
      slots={{
        transition: SlideTransition
      }}>
      <DialogTitle>{intl.formatMessage({ id: title ? title : 'confirm-add-policy-dialog-title' })}</DialogTitle>
      <DialogContent>
        <Typography color="textSecondary" gutterBottom={true}>
          {intl.formatMessage({ id: 'choose-next-action' })}
        </Typography>
        <Grid
          className="next-actions"
          container
          spacing={2}
          sx={{
            justifyContent: "center",
            alignItems: "center"
          }}>
          {onRider && (
            <Grid size={{ xs: 12, sm: 3 }}>
              <Button variant="outlined" color="primary" onClick={onRider}>
                {intl.formatMessage({ id: 'Add Rider' })}
              </Button>
            </Grid>
          )}
          {onAnother && (
            <Grid size={{ xs: 12, sm: 3 }}>
              <Button variant="outlined" color="primary" onClick={onAnother}>
                {intl.formatMessage({ id: 'add-another-policy' })}
              </Button>
            </Grid>
          )}
          {/* {onExport && (
            <Grid size={{ xs: 6, sm: 3 }}>
              <Button
                variant="outlined"
                color="primary"
                startIcon={<img alt="portfolio" src="img/export_blue.svg" height="20" />}
                onClick={onExport}
              >
                {intl.formatMessage({ id: 'After_add_Export_action' })}
              </Button>
            </Grid>
          )} */}
        </Grid>
      </DialogContent>
      <DialogActions>
        {onClose && (
          <Button onClick={onClose} color="primary">
            {intl.formatMessage({ id: 'Cancel' })}
          </Button>
        )}
        <Button onClick={onSubmit} color="primary">
          {intl.formatMessage({ id: 'OK' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default injectIntl(ConfirmAddPolicyDialog);
